/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import get from 'lodash/get';
import { Banner, Button, StaticAccordion, SearchBox } from 'components';
import { HELPER, JsBridge } from 'utils';
import {
  BILLER_PAGE,
  SERVICE_CACHE,
  BILLER_CACHE,
  CACHE_CUSTOMER_NUMBER,
} from 'constant/ConstVariable';
import { ERROR_DEFAULT } from 'assets';

import config from './BillerPage.page.config';
import text from './BillerPage.page.translation';
import './BillerPage.less';
class BillerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionBiller: [],
      updateAccordion: true,
      serviceImage: [],
      serviceData: {},
      status: {
        code: 0,
        message: '',
        isService: false,
      },
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    // Set Accordion Biller if Data Already Have
    if (prevProps.billerList.length > 0 && prevState.updateAccordion) {
      const billerList = prevProps.billerList.map(item => ({
        id: item.id,
        name: item.name,
        icon: item.icon_abs_url,
        status: {
          pground_status: item.pground_status,
          skyw_status: item.skyw_status,
        },
      }));
      // Name Must Be Sort Before Filtering
      const sortBillerList = billerList.sort(HELPER.dynamicObjectSort('name'));
      // Data Must Hook To Filtering Search Before Final Convert To Accordion
      const afterSearch = HELPER.objectSearch(sortBillerList, '');
      // Applying Converter Object to Format Support Accordion Element
      const getObject = HELPER.convertBillerListToAccordion(afterSearch);
      // Update State
      return {
        accordionBiller: getObject,
        updateAccordion: false,
      };
    }
    // Return null to indicate no change to state.
    return null;
  }

  getIDService = () => this.props.match.params.id;

  _onBack = e => {
    e && e.preventDefault();

    JsBridge.close();
  };

  _initPage = () => {
    const stateCached = sessionStorage.getItem(SERVICE_CACHE);
    sessionStorage.removeItem(CACHE_CUSTOMER_NUMBER);
    if (stateCached) {
      const buildDataCache = {
        data: {
          payload: JSON.parse(stateCached),
        },
      };
      this.onSuccessGetService(buildDataCache);
    } else {
      this.props.getService(this.getIDService()).then(this.onSuccessGetService);
    }
  };

  componentDidMount() {
    JsBridge.on('back', this._onBack);
    sessionStorage.setItem(BILLER_PAGE, true);
    JsBridge.setDefaultBack();

    this._initPage();
  }

  componentWillUnmount() {
    JsBridge.off('back', this._onBack);
  }

  onSuccessGetService = result => {
    try {
      const { payload } = result.data;
      const title = payload.public_name || payload.name;
      const prevStatus = this.state.status;
      const newStatus = { ...prevStatus, isService: payload.is_active };
      sessionStorage.setItem(SERVICE_CACHE, JSON.stringify(payload));
      document.addEventListener(
        'AlipayJSBridgeReady',
        () => {
          JsBridge.setTitle(title);
        },
        false,
      );
      this.setState(
        {
          status: newStatus,
          serviceImage: payload.banner_abs_url,
          serviceData: payload,
        },
        this.onSuccessGetServiceNext(payload.id),
      );
    } catch (error) {
      // If Everting Process Service Detail Failure Set Service is unavailable
      this.setServiceAvailable(400);
    }
  };

  onSuccessGetServiceNext = serviceId => () => {
    const params = {
      page_num: 1,
      page_size: 500,
    };

    this.props.getListBillerByService(serviceId, params);
    this.setServiceAvailable(200);
  };

  setServiceAvailable = stateCode => {
    const { status } = this.state;
    const {
      intl: { formatMessage },
    } = this.props;
    const newStatus = { ...status };
    newStatus.code = stateCode;
    switch (stateCode) {
      case 400:
        newStatus.message = formatMessage(text.servicenotfound);
        newStatus.isService = false;
        break;
      case 200:
        newStatus.message = formatMessage(text.servicefetch);
        break;
      default:
        this.setState({
          status: newStatus,
        });
    }
    this.setState({
      status: newStatus,
    });
  };

  accordionNavigate = id => {
    sessionStorage.removeItem(BILLER_CACHE);
    this.props.history.push(`biller/${id}`);
  };

  _searchOnChange = event => {
    // Short Before Filter
    const billerList = this.props.billerList.map(item => ({
      id: item.id,
      name: item.name,
      icon: item.icon_abs_url,
      status: {
        pground_status: item.pground_status,
        skyw_status: item.skyw_status,
      },
    }));
    const sortBillerList = billerList.sort(HELPER.dynamicObjectSort('name'));
    // Data Must Hook To Filtering Search Before Final Convert To Accordion
    const afterSearch = HELPER.objectSearch(sortBillerList, event.target.value);

    // Applying Converter Object to Format Support Accordion Element
    const getObject = HELPER.convertBillerListToAccordion(afterSearch);
    // Update State
    this.setState({
      accordionBiller: { ...getObject },
    });
  };

  _openStickyForm = () => {
    if (window.IS_IN_SKYWALKER) {
      JsBridge.call('callSubApp', {
        url: process.env.SURVEY_URL,
      });
    } else {
      window.location.assign(process.env.SURVEY_URL);
    }
  };

  render() {
    const {
      status,
      accordionBiller,

      serviceImage,
      serviceData,
    } = this.state;
    const {
      isLoading,
      deviceHeight,
      billerList,
      intl: { formatMessage },
    } = this.props;
    const accordionConfig = {
      data: { ...accordionBiller },
      itemClick: this.accordionNavigate,
    };

    const allowSearchBar =
      billerList.filter(biller => biller.skyw_status !== '3').length > 5;

    const isBetaVersion = get(serviceData, 'name', '')
      .toLowerCase()
      .includes('(beta)');

    if (isLoading) {
      return '';
    }
    if (!!this.getIDService() && status.isService) {
      return (
        <div className="billers" style={{ height: `${deviceHeight}px` }}>
          <div
            className="biller-list"
            style={{
              height: isBetaVersion
                ? `calc(${deviceHeight}px - 6.5rem)`
                : `${deviceHeight}px`,
            }}
          >
            <Banner imgSource={serviceImage} />
            {allowSearchBar && (
              <div className="section-search">
                <SearchBox
                  placeholder={`${formatMessage(text.findServiceText)}`}
                  onChange={this._searchOnChange}
                />
              </div>
            )}

            <StaticAccordion {...accordionConfig} />
          </div>

          {isBetaVersion && (
            <div className="sticky-info">
              <span>
                {formatMessage(text.sticky.text)}
                <span onClick={this._openStickyForm} className="link">
                  {formatMessage(text.sticky.btn)}
                </span>
              </span>
            </div>
          )}
        </div>
      );
    }

    return (
      <div id="unavailable-page">
        <div className="body">
          <img
            className="icon-maintenance"
            src={ERROR_DEFAULT}
            alt="icon maintenance"
          />
          <span className="title">{formatMessage(text.unavailable.title)}</span>
          <span className="description">
            {formatMessage(text.unavailable.desc)}
          </span>
        </div>

        <div className="footer">
          <Button type="full primary" action={this._initPage}>
            <span className="button-text">
              {formatMessage(text.unavailable.btn)}
            </span>
          </Button>
        </div>
      </div>
    );
  }
}

BillerPage.propTypes = config.propTypes;
BillerPage.displayName = config.displayName;
BillerPage.defaultProps = config.defaultProps;

export default BillerPage;
